/* eslint-disable */
import React from "react";
import { ThemeContext, themes } from "../../themes/ThemeContext";

function AICourseCreator() {
  const theme = React.useContext(ThemeContext);
  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 rounded-md overflow-hidden min-h-screen" style={{color: theme.colors.text.primary}}>
      <div className="">
        <div className="pageTitle text-3xl font-semibold">
          AI Course Creator
        </div>
        <div className="tag text-md mt-2 text-xs font-thin">
          {/* Update your Profile Details */}
        </div>
      </div>
      <div className="text-lg w-1/2" style={{ lineHeight: "50px" }}>
        Hey there,
        <br />
        Thank you for grabbing the AI course creator.
        <br />
        Kindly click this link to create your account: <a href="https://aibeamapp.com/register" className="text-blue-500">https://aibeamapp.com/register</a>.
        <br />
        <div className="font-semibold">Thank you</div>
      </div>
    </div>
  );
}

export default AICourseCreator;
